import { Collapse } from 'reactstrap';
import PropTypes  from 'prop-types';
import React from 'react';
import classnames from "classnames";
import { getPrimaryTextClass } from 'helpers/sf_utils';

const AccordionItem = ({icon, name, sectionName, functionName, clildren }) => {
    return (
        <div className="accordion-item bg-white rounded border-0 mb-3">
            <h2 className="accordion-header" id={`heading_${name.split(" ").join("_")}`}>
                <button 
                    className={classnames(
                        "accordion-button bg-white rounded border-0", 
                        "text-black", 
                        "shadow-none", 
                        "font-weight-semibold", 
                    { collapsed: !sectionName })} 
                    type="button" 
                    onClick={functionName} >
                    <i className={`bx ${icon} ${getPrimaryTextClass()} me-2 bx-sm`} />
                    {name}
                </button>
            </h2>
            <Collapse isOpen={sectionName} className="accordion-collapse">
                <div className="accordion-body pt-0">
                    {!!sectionName && clildren}
                </div>
            </Collapse>
        </div>
    );
}

AccordionItem.propTypes = {
    icon: PropTypes.string,
    name: PropTypes.string,
    sectionName: PropTypes.bool,
    functionName: PropTypes.func,
    clildren: PropTypes.element,
}
export default AccordionItem;